// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"FeaturedDoodle_mainContainer__bpynx","doodleContainer":"FeaturedDoodle_doodleContainer__1inmp"};